define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/AddPath",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/xml"
], function(declare, lang, def, AddPath, Field, Relationship, FormWidget, locale, xml) {

	return declare(FormWidget, {
		_resolveView: function() {
			var section = this.getFormData().getSource().getParent();
			var batch = this.getCache().getNode(section.__Parent__, true);

			this.defView.addField(lang.mixin(new Field(), {
				m_label: "Colorway",
				idParameter: "Colorway",
				m_bRequired: true,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_relationship: lang.mixin(new Relationship(), {
					m_url: batch.__Parent__,
					m_id: "InspectionColorways"
				})
			}));

			this.defView.addField(lang.mixin(new Field(), {
				m_label: "Size",
				idParameter: "Size",
				m_bRequired: true,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_relationship: lang.mixin(new Relationship(), {
					m_url: batch.__Parent__,
					m_addPaths: [lang.mixin(new AddPath(), {
						m_path: "Child:FISizeCharts/Child:Sizes"
					})],
					m_sorts: [{id: "SizeCode"}]
				})
			}));

			this.addDefaultValue(xml.ATTR_NAME, locale.resource("FinalInspectionBatchSample"));
			this.inherited(arguments);
		}
	});
});